/**
 *  开发完单页面组件请在这里注册
 *  前台根据权限编号去匹配相应组件
 *  开发时组件的name须与权限权限树的编号一致
 *  找不到匹配的组件将匹配默认组件common-grid.vue
 */
import Demo from './grid/demo.vue'
import BasicMailGrid from './grid/basic-mail-grid.vue'
import DemoHelloWorld from './demo/demo-hello-world.vue'
import DemoVueUeditor from './demo/demo-vue-ueditor.vue'
import DemoSPage1 from './demo/demo-spage-1'
import DemoSPage2 from './demo/demo-spage-2'
import DemoSPage3 from './demo/demo-spage-3'
import DemoSPage4 from './demo/demo-spage-4'
import DemoSPage5 from './demo/demo-spage-5'
import TestWsSender from './demo/websocket/test-ws-sender'
import TestWsReceiver1 from './demo/websocket/test-ws-receiver1'
import TestWsReceiver2 from './demo/websocket/test-ws-receiver2'
import DemoChart1 from './demo/chart/demo-chart1'
import DemoStudentManageDc from './grid/demo-student-manage-dc'

import classRoomAdd from './jpcp/classRoom-add.vue'
import classRoomUpdate from './jpcp/classRoom-update.vue'
import testfileUpload from './jpcp/file/fileUpload-test.vue'
import unitdelegationViewUpdatePhoto from './jpcp/unitdelegation-view-update-photo.vue'
import departmentViewUpdatePhoto from './jpcp/department-view-update-photo.vue'
import projectAdd from './jpcp/project/project-add.vue'
import projectView from './jpcp/project/project-view.vue'
import graduationView from './jpcp/project/graduation-view.vue'
import printCertificate from './jpcp/project/graduation-printCertificate.vue'
import dashboardjpcp from './jpcp/dashboard.vue'
import projectUpdate from './jpcp/project/project-update.vue'

import fileDownload from './jpcp/project/file-download.vue'
import projectBill from './jpcp/project/projectBill-add.vue'

import jpcpDataChar from './jpcp/project/jpcp-data-char.vue'
import departDashboard from './jpcp/project/depart-dashboard-char.vue'
import studentDataChar from './jpcp/project/student-data-char.vue'
import projectBillDataChar from './jpcp/project/projectBill-data-char.vue'
import resourceDataChar from './jpcp/project/resource-data-char.vue'
import otherDataChar from './jpcp/project/other-data-char.vue'
import uploadProjectResource from './jpcp/project/upload-project-resource.vue'
import projectChange from './jpcp/projectChange/project-change.vue'
import jumpView from './jpcp/jump-view.vue'
import expenditureDataChar from './jpcp/project/expenditure-data-char'
import projectCopy from './jpcp/project/project-copy.vue'




const customComponentsMap = {}
// 定义的组件写到这个数组中
const customComponents = [
  Demo, BasicMailGrid, DemoHelloWorld, DemoVueUeditor,
  DemoSPage1, DemoSPage2, DemoSPage3, DemoSPage4, DemoSPage5,
  TestWsSender, TestWsReceiver1, TestWsReceiver2,
  DemoChart1, DemoStudentManageDc,classRoomAdd,classRoomUpdate,
  testfileUpload,
  unitdelegationViewUpdatePhoto,departmentViewUpdatePhoto,
  projectAdd,projectView,graduationView,printCertificate,dashboardjpcp,
  projectUpdate,jpcpDataChar,projectBill,fileDownload,departDashboard,
  otherDataChar,studentDataChar,projectBillDataChar,resourceDataChar,uploadProjectResource,
  projectChange,jumpView,expenditureDataChar,projectCopy
]

for (let i = 0; i < customComponents.length; i++) {
  customComponentsMap[customComponents[i].name] = customComponents[i]
}

export default customComponentsMap



// WEBPACK FOOTER //
// ./src/custom/components/custom-components-register.js